export const SCOPE = "modules/booking/";

export const GET_BOOKING_INFO = SCOPE + "GET_BOOKING_INFO";
export const BOOK_TIME = SCOPE + "BOOK_TIME";
export const SUGGEST_TIME = SCOPE + "SUGGEST_TIME";
export const RESCHEDULE_BOOKING = SCOPE + "RESCHEDULE_BOOKING";
export const CANCEL_BOOKING = SCOPE + "CANCEL_BOOKING";
export const GET_BOOKED_CALLS = SCOPE + "GET_BOOKED_CALLS";
export const GET_BOOKED_CALL_DETAIL = SCOPE + "GET_BOOKED_CALL_DETAIL";
export const GET_WAITING_FOR_FEEDBACK_INSIDERS =
  SCOPE + "GET_WAITING_FOR_FEEDBACK_INSIDERS";
export const GET_CALL_OBJECTIVES = SCOPE + "GET_CALL_OBJECTIVES";
export const GET_BOOKING_DETAIL = SCOPE + "GET_BOOKING_DETAIL";
export const DELETE_SUB_OBJECTIVE = SCOPE + "DELETE_SUB_OBJECTIVE";
export const APPLY_PROMO_CODE = SCOPE + "APPLY_PROMO_CODE";



// WEBPACK FOOTER //
// ./src/modules/booking/types.js